<template>
	<transition name="slide-small-fade">
		<div v-if="show" class="tooltip">
			<slot />
		</div>
	</transition>
</template>

<script>
export default {
	props: {
		show: Boolean
	}
}
</script>

<style lang="scss" scoped>
.tooltip {
	font-weight: bold;
	position: absolute;
	background: WHITE;
	color: #ffffff;
	text-align: center;
	padding: 15px 20px 15px 20px;
	border-radius: 15px;
	bottom: calc(100% - 30px);
	left: 50%;
	margin-left: -150px;
	z-index: 1000;
	font-size: 14px;
	width: 300px;
	color: $blue;
	box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.2);

	&:after {
		content: '';
		border-width: 20px 20px 0 20px;
		border-style: solid;
		border-color: white transparent transparent transparent;
		position: absolute;
		bottom: -9px;
		left: 50%;
		transform: translateX(-50%);
	}
}
</style>
